import { useApiMutation } from "./use-api-mutation";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request";

type ReplayOneStockParams = {
	returnRequestId: string;
	action: "create" | "cancel";
};

export default function useReplayOneStock(shopId: string) {
	const invalidateReturnRequest = useInvalidateReturnRequest();

	return useApiMutation(
		"post",
		"/shops/{shopId}/integrations/onestock/replay",
		{
			onSuccess: (_, variables: ReplayOneStockParams) => {
				invalidateReturnRequest({
					shopId,
					returnRequestId: variables.returnRequestId,
				});
			},
			mapVariables: ({ returnRequestId, action }: ReplayOneStockParams) => ({
				params: { path: { shopId } },
				body: {
					returnRequestId,
					action,
				},
			}),
		},
	);
}
